export enum OperationalAreaStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}
